import { render } from "./SettingsAccountAdd.vue?vue&type=template&id=5904cc0a"
import script from "./SettingsAccountAdd.vue?vue&type=script&lang=js"
export * from "./SettingsAccountAdd.vue?vue&type=script&lang=js"

import "./SettingsAccountAdd.vue?vue&type=style&index=0&id=5904cc0a&lang=scss"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__